import React from "react"
import { Helmet } from "react-helmet-async"
import { Container } from "reactstrap"

import PurchaseOrder from "components/PurchaseOrders/purchaseOrder"
import EntitlementPageGuard from "components/Subscription/EntitlementPageGuard"
import { PURCHASE_ORDERS } from "constants/entitlements"

const PurchaseOrderIndex = () => {
  return (
    <EntitlementPageGuard permission={PURCHASE_ORDERS}>
      <div className="page-content">
        <Helmet>
          <title>Planhopper | Pedidos de compra</title>
        </Helmet>
        <Container fluid>
          <PurchaseOrder />
        </Container>
      </div>
    </EntitlementPageGuard>
  )
}

export default PurchaseOrderIndex
